var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
  * Demonstrates the rendered result of a Perseus question within an iframe.
  *
  * This mounts an ItemRenderer, HintRenderer, or ArticleRenderer(s)
  * (depending on the content given) and applies mobile styling if necessary.
  * NOTE(amy): The KA CMS preview relies on preview-frame.jsx in webapp's
  * perseus-preview-package (which largely duplicates this logic)
  */

var React = require("react");

var ItemRenderer = require("./item-renderer.jsx");
var HintRenderer = require("./hint-renderer.jsx");
var ArticleRenderer = require("./article-renderer.jsx");
var TouchEmulator = require("../lib/touch-emulator.js");

var PreviewFrame = React.createClass({
    displayName: "PreviewFrame",

    propTypes: {
        isMobile: React.PropTypes.bool.isRequired
    },

    getInitialState: function getInitialState() {
        return {};
    },

    componentDidMount: function componentDidMount() {
        var _this = this;

        window.addEventListener("message", function (event) {
            var data = window.parent.iframeDataStore[event.data];

            if (data) {
                _this.setState(data);
            }
        });

        window.parent.postMessage(window.frameElement.getAttribute("data-id"), "*");

        this._updateParentWithHeight();

        if (window.MutationObserver) {
            // To know when to update the parent with the new iframe content
            // height, we listen to DOM mutations inside the iframe and
            // update the parent with the latest height every time a
            // mutation is detected.
            this._observer = new MutationObserver(function () {
                _this._updateParentWithHeight();
            });

            this._observer.observe(document.getElementById("measured"), {
                childList: true,
                subtree: true,
                attributes: true
            });
        }

        // In addition to mutation observers, we also periodically check the
        // height to capture the result of animations.
        setInterval(function () {
            _this._updateParentWithHeight();
        }, 500);

        if (this.props.isMobile) {
            TouchEmulator();
        }

        // article-all means that we are rendering a full preview of an article
        if (this.state.type === "article-all") {
            document.body.style.overflow = "scroll";
        } else {
            document.body.style.overflow = "hidden";
        }
    },

    componentDidUpdate: function componentDidUpdate() {
        if (this.state.type === "article-all") {
            document.body.style.overflow = "scroll";
        } else {
            document.body.style.overflow = "hidden";
        }
    },
    componentWillUnmount: function componentWillUnmount() {
        if (this._observer) {
            this._observer.disconnect();
        }
    },


    _updateParentWithHeight: function _updateParentWithHeight() {
        var lowest = 0;
        ["#content-container", ".preview-measure"].forEach(function (selector) {
            Array.from(document.querySelectorAll(selector)).forEach(function (element) {
                lowest = Math.max(lowest, element.getBoundingClientRect().bottom);
            });
        });

        var bottomMargin = 30;

        window.parent.postMessage({
            id: window.frameElement.getAttribute("data-id"),
            height: lowest + bottomMargin
        }, "*");
    },

    render: function render() {
        var _this2 = this;

        if (this.state.data) {
            var makeUpdatedData = function makeUpdatedData(data) {
                return _extends({}, data, {
                    workAreaSelector: "#workarea",
                    hintsAreaSelector: "#hintsarea",
                    apiOptions: _extends({}, data.apiOptions, {
                        isMobile: _this2.props.isMobile
                    })
                });
            };

            var isExercise = this.state.type === "question" || this.state.type === "hint";

            var perseusClass = "framework-perseus fonts-loaded " + (isExercise ? "bibliotron-exercise " : "bibliotron-article ") + (this.props.isMobile ? "perseus-mobile" : "");

            var linterContext = this.state.data.linterContext;

            if (this.state.type === "question") {
                return React.createElement(
                    "div",
                    {
                        className: perseusClass,
                        style: this.props.isMobile ? {} : { margin: "30px 0" },
                        ref: "container"
                    },
                    React.createElement(ItemRenderer, _extends({}, makeUpdatedData(this.state.data), {
                        linterContext: linterContext
                    })),
                    React.createElement("div", { id: "workarea", style: { marginLeft: 0 } }),
                    React.createElement("div", { id: "hintsarea" })
                );
            } else if (this.state.type === "hint") {
                return React.createElement(
                    "div",
                    {
                        className: perseusClass,
                        style: this.props.isMobile ? {} : { margin: "30px 0" },
                        ref: "container"
                    },
                    React.createElement(HintRenderer, _extends({}, makeUpdatedData(this.state.data), {
                        linterContext: linterContext
                    }))
                );
            } else if (this.state.type === "article") {
                return React.createElement(
                    "div",
                    {
                        className: perseusClass,
                        style: this.props.isMobile ? {} : { margin: "30px 0" }
                    },
                    React.createElement(ArticleRenderer, _extends({}, makeUpdatedData(this.state.data), {
                        linterContext: linterContext
                    }))
                );
            } else if (this.state.type === "article-all") {
                return React.createElement(
                    "div",
                    {
                        className: perseusClass,
                        style: this.props.isMobile ? {} : { margin: "30px 0" }
                    },
                    this.state.data.map(function (data, i) {
                        return React.createElement(ArticleRenderer, _extends({
                            key: i
                        }, makeUpdatedData(data), {
                            linterContext: linterContext
                        }));
                    })
                );
            } else {
                return React.createElement("div", null);
            }
        } else {
            return React.createElement("div", null);
        }
    }
});

module.exports = PreviewFrame;


/*****************
 ** WEBPACK FOOTER
 ** ./src/preview-frame.jsx
 ** module id = 10
 ** module chunks = 2
 **/